import type { ApiEnvs } from '@peloton/external-links/models';
// eslint-disable-next-line no-restricted-imports
import {
  toOauthConfig,
  apiEnvToOauthEnv,
  OauthEnvironment,
  toEnv,
} from '@engage/env/oauthEnv';
import { toApiEnv } from '@members/env/api';

type Auth0Config = ReturnType<typeof toOauthConfig>;

const Auth0EnvConfigs = Object.entries(apiEnvToOauthEnv).reduce(
  (auth0EnvConfig, [apiEnv, oauthEnv]) => ({
    ...auth0EnvConfig,
    [apiEnv]: toOauthConfig(oauthEnv),
  }),
  {} as Partial<Record<ApiEnvs, Auth0Config>>,
);

export const apiToMaybeOauthEnv = (str?: string): OauthEnvironment | undefined => {
  const api = str ?? toApiEnv();
  // @ts-expect-error (TS7053): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ api: OauthEnvironment; qa2: OauthEnvironment; qa1: OauthEnvironment; 'api.api-core.dev.k8s': OauthEnvironment; }'.
  const env = toEnv(apiEnvToOauthEnv[api]);

  return env === OauthEnvironment.Unknown ? undefined : env;
};

export const toAuth0Config = (
  apiEnv: ApiEnvs,
  oauthEnv?: OauthEnvironment,
): Auth0Config => {
  if (oauthEnv) {
    return toOauthConfig(oauthEnv);
  }

  return Auth0EnvConfigs[apiEnv] ?? toOauthConfig(OauthEnvironment.Stage);
};
